"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logout = void 0;
/**
 * It represents the logout information
 *
 * @property {string}        redirectUrl     - redirect url for logout
 *
 * @author jennifer.ajoy
 */
var Logout = /** @class */ (function () {
    function Logout(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    return Logout;
}());
exports.Logout = Logout;
